import { sessionConstants } from '../constants';

export function sessionCSVHistory(state = {}, action) {
  switch (action.type) {
    case sessionConstants.GETSESSION_CSV_HISTORY_REQUEST:
      return {
        loading: action.res
      };
    case sessionConstants.GETSESSION_CSV_HISTORY_SUCCESS:
      console.log("res from reducer", action)
      return {
        ...state,
        session_csv: action.res,
        loading: false,
      };
    case sessionConstants.GETSESSION_CSV_HISTORY_FAILURE:
      return {
        error: action.error,
        loading: false
      };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/sessionCSVHistory.reducer.js